import { useQuery } from '@tanstack/react-query';

import { workflowMetricsKeys } from '@/domains/workflows/api/workflow-metrics/query-keys';

export const useActivePerWorkflowStatsQuery = () => {
  const {
    data = [],
    isLoading,
    isFetching,
  } = useQuery(
    // @ts-ignore
    workflowMetricsKeys.workflowRuntimeStats(),
  );

  return {
    data,
    isFetching,
    isLoading,
  };
};
